
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Message',
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'success'
    }
  }
});
